export default function createSftpReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'CREATE_SFTP_CREDENTIAL_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'CREATE_SFTP_CREDENTIAL_ERROR':
            return {...state, ...{error: action.error}};

        case 'CREATE_SFTP_CREDENTIAL_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}